import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {
  ValidationInput,
  Row,
  Col,
  Alert,
  InputContainer,
  SelectPure,
  CustomerDialogButtonRow,
  WarningAlert,
} from '@modifi/ui'
import {TransactionRemovalReason} from '@modifi/enums'

import ms from 'ms'
import {Description, Headline} from '../delete-transaction-dialog/styles'
import {useAbility} from '../../../../constants/permissions'
import {TRANSACTION} from '../../../../constants/section'

const SelectPureContainer = props => <InputContainer inputComponent={SelectPure} {...props} />

const getInvestorOptions = partners =>
  partners.map(partner => ({
    value: partner.tag,
    label: partner.name,
  }))

const getSelectedValue = (value, partners) => {
  const selectedPartner = partners.find(partner => partner.tag === value)
  if (!selectedPartner) return null
  return {
    value,
    label: selectedPartner.name,
  }
}

const SpvRemovalDialog = ({
  params: {id},
  fetchRefinancingPartners,
  refinancingPartners,
  deleteTransaction,
  isDeleting,
  deleteError,
  fetchError,
  closeDialog,
}) => {
  const [refinancingPartner, setRefinancingPartner] = useState('')

  useEffect(() => {
    fetchRefinancingPartners(id)
  }, [fetchRefinancingPartners, id])

  const ability = useAbility()
  const isAllowed = ability.can('update', TRANSACTION)

  const handleInvestorChange = value => {
    setRefinancingPartner(value)
  }

  return (
    <>
      {!isAllowed && (
        <Row mt={30} mb={10}>
          <Col col={10} offset={1}>
            <WarningAlert>
              You are lacking permissions to adjust values in this section
            </WarningAlert>
          </Col>
        </Row>
      )}
      <Row mt={30}>
        <Col col={10} offset={1}>
          <Headline>Are you sure you want to want to mark this transaction as SPV?</Headline>
        </Col>
      </Row>
      <Row mt={20} mb={50}>
        <Col col={10} offset={1}>
          <Description>This can&apos;t be undone</Description>
        </Col>
      </Row>
      {(fetchError || deleteError) && (
        <Row mt={30} mb={10}>
          <Col col={10} offset={1}>
            <Alert type="danger">
              {fetchError
                ? 'Something went wrong while fetching your refinancing partners, please try again later'
                : 'Something went wrong while removing this transaction, please try again later'}
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col col={10} offset={1}>
          <ValidationInput
            inputComponent={SelectPureContainer}
            noBlur
            name="investor"
            placeholder="Select"
            label="Select investor"
            onChange={({value}) => handleInvestorChange(value)}
            options={getInvestorOptions(refinancingPartners)}
            value={getSelectedValue(refinancingPartner, refinancingPartners)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <CustomerDialogButtonRow
            canSubmit={!isDeleting && !fetchError && !!refinancingPartner && isAllowed}
            onSubmitClick={() =>
              deleteTransaction(id, TransactionRemovalReason.SPV_TRANSACTION, refinancingPartner)
            }
            submitText="MARK AS SPV"
            alert
            hasCancel
            canCancel
            cancelText="CANCEL"
            onCancelClick={closeDialog}
            expectedSubmitDuration={ms('1s')}
          />
        </Col>
      </Row>
    </>
  )
}

SpvRemovalDialog.propTypes = {
  refinancingPartners: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  fetchRefinancingPartners: PropTypes.func.isRequired,
  params: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  deleteTransaction: PropTypes.func.isRequired,
  deleteError: PropTypes.string,
  isDeleting: PropTypes.bool.isRequired,
  fetchError: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
}

SpvRemovalDialog.defaultProps = {
  deleteError: null,
  refinancingPartners: [],
}

export default SpvRemovalDialog
